export function initProdejny() {
    const sel = document.getElementById('region-select');
    const all = [...document.querySelectorAll('details[id^="kraj-"]')];

    const normalize = v => v?.replace(/^region-/, 'kraj-');

    const open = (rawId) => {
        const id = normalize(rawId);
        if (!id) return;
        all.forEach(d => d.open = (d.id === id));
        const el = document.getElementById(id);
        console.log('open()', rawId, '→', id, 'exists:', !!el);
        if (el) {
            el.querySelector('summary')?.focus?.({ preventScroll: true });
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            location.hash = id;
        } else {
            console.warn('neexistuje element #' + id);
        }
    };

    sel?.addEventListener('change', e => open(e.target.value));

    const initial = normalize(location.hash?.slice(1));
    if (initial && document.getElementById(initial)) open(initial);
}
